import { defineStore } from 'pinia';
import { ref } from 'vue';

import { type MessageTemplate } from './template.type';

export const useTemplate = defineStore(
  'template',
  () => {
    const showTemplateModal = ref(false);
    const selectedTemplate = ref<MessageTemplate | null>(null);
    const templates = ref<MessageTemplate[]>([]);

    /**
     * Drops everything template-related. The list is per-user but this store is
     * `persist: true` and not keyed by user, so it has to be emptied whenever the
     * signed-in user changes — otherwise the next person to use this browser reads
     * the previous user's custom templates straight out of localStorage.
     */
    function clear() {
      selectedTemplate.value = null;
      showTemplateModal.value = false;
      templates.value = [];
    }

    // alphabetized list
    return {
      clear,
      selectedTemplate,
      showTemplateModal,
      templates,
    };
  },
  {
    persist: true,
  },
);
